import React from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';

const CustomOverlayPanel = ({
  children,
  op,
  className = '',
  onShow,
  appendTo,
}) => (
  <OverlayPanel
    ref={op}
    appendTo={appendTo}
    onShow={onShow}
    style={{ backgroundColor: '#fff' }}
    className={['custom-overlay', 'more-actions-overlaypanel', className].filter(Boolean).join(' ')}
  >
    {children}
  </OverlayPanel>
);

export default CustomOverlayPanel;